import { CustomLineData } from './data';
import { CustomLineSeriesOptions, defaultOptions } from './options';
import { CustomLineSeriesRenderer } from './renderer';
import {
  CustomSeriesPricePlotValues,
  ICustomSeriesPaneView,
  PaneRendererCustomData,
  WhitespaceData,
  Time,
} from 'lightweight-charts';

export class CustomLineSeries<TData extends CustomLineData = CustomLineData> implements ICustomSeriesPaneView<
  Time,
  TData,
  CustomLineSeriesOptions
> {
  _renderer: CustomLineSeriesRenderer<TData>;

  constructor() {
    this._renderer = new CustomLineSeriesRenderer();
  }

  priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
    return [plotRow.value];
  }

  isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
    return (data as Partial<TData>).value === undefined;
  }

  renderer(): CustomLineSeriesRenderer<TData> {
    return this._renderer;
  }

  update(data: PaneRendererCustomData<Time, TData>, options: CustomLineSeriesOptions): void {
    this._renderer.update(data, options);
  }

  defaultOptions() {
    return defaultOptions;
  }
}
